var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandTransit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20711 8C0.761654 8 0.538571 7.46143 0.853553 7.14645L7.64645 0.353553C7.84171 0.158291 8.15829 0.158291 8.35355 0.353553L15.1464 7.14645C15.4614 7.46143 15.2383 8 14.7929 8L8 8L1.20711 8Z",
    fill: "#3F4D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandTransit);
export default __webpack_public_path__ + "static/media/expand_transit.b89e7dd0e77dc607d45c31386b041d8d.svg";
export { ForwardRef as ReactComponent };